import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth, db } from "../firebase";
import { doc, getDoc, getDocs, query, collection, where } from "firebase/firestore";
import "./../App.css"
import { useNavigate } from "react-router-dom";

function Menu() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("Guest");
    const [userData, setUserData] = useState(null);
    const [propertyStatus, setPropertyStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [propertyName, setPropertyName] = useState("");
    const [propertyLogo, setPropertyLogo] = useState("");
    const [documentStatus, setDocumentStatus] = useState(null);

    const [openMenu, setOpenMenu] = useState(null);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!userData) return;

                const userRef = doc(db, "users", userData.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const user = userSnap.data();
                    setUsername(user.name || "Guest");

                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [userData]);



    const linkStyle = {
        color: "#fff",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "15px 15px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        borderBottom: "1px solid rgba(245, 238, 238, 0.2)",
        cursor: "pointer",
        position: "relative"
    };

    const linkHover = {
        background: "rgba(255,255,255,0.15)",
        transform: "translateX(6px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(255,255,255,0.07)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
        display: "block"
    };

    const iconStyle = {
        fontSize: "20px",
        width: "45px",
        textAlign: "center"
    };

    const arrowIconStyle = {
        marginLeft: "auto",
        transition: "0.3s",
        fontSize: "14px"
    };

    const firstLetter = username.charAt(0).toUpperCase();


    const fullMenu = [

        { icon: "fas fa-home", text: "Dashboard", link: "/home" },
        {
            icon: "fas fa-list",
            text: "Daily Tasks",
            submenu: [
                { text: "Daily Posts", link: "/daily-posts" },
                { text: "Approvals", link: "/approvals" },
                { text: "Income Expense Approvals", link: "/income-expense-approval" },
                { text: "Notices", link: "/notices" },
                { text: "Chat", link: "/chat" },
                { text: "All Chats", link: "/all-chats" },
                { text: "Video Meetings", link: "/video-mettings" },
            ]
        },

        {
            icon: "fa fa-whatsapp",
            text: "Whatsapp",
            submenu: [
                { text: "Send Whatsapp", link: "/send-whatsapp" },
                { text: "Whatsapp History", link: "/whatsapp-history" },
                { text: "Contact Division", link: "/contacts-divison" },
                { text: "Active Contacts", link: "/active-contacts" },
                { text: "Inactive Contacts", link: "/inactive-contacts" },
            ]
        },

        {
            icon: "fas fa-table",
            text: "Reception",
            submenu: [
                { text: "Guest Enquiry", link: "/guest-enquiry" },
                { text: "Student Out Pass", link: "/student-outpass" },
                { text: "Staff Out Pass", link: "/staff-outpass" },
                { text: "Hostel Student Out Pass", link: "/student-hostel-outpass" },
                { text: "Hostel Student In Pass", link: "/student-hostel-inpass" },
                { text: "Admission Enquiry", link: "/admission-enquiry" },
                { text: "Thumb Registration", link: "/thumb-registration" },
            ]
        },

         {
            icon: "fas fa-pen",
            text: "Attendance",
            submenu: [
                { text: "Student Attendance", link: "/student-attendance" },
                { text: "Teachers Attendance", link: "/teachers-attendance" },
                // { text: "Staff Attendance", link: "/staff-attendance" },
            ]
        },

        {
            icon: "fas fa-user-graduate",
            text: "Student Mgmt",
            submenu: [
                { text: "Admission Process", link: "/admission-process" },
                { text: "Student Profiles", link: "/students" },
                { text: "Document Upload", link: "/student-documents" },
                { text: "Student Wallet", link: "/student-wallet" },
                { text: "Parent Profiles", link: "/parents-mgmt" },
                { text: "ID Card Generation", link: "/id-card-generation" },
            ]
        },

        {
            icon: "fas fa-chalkboard-teacher",
            text: "Teachers Mgmt",
            submenu: [
                // { text: "Add Teacher", link: "/add-teacher" },
                { text: "All Teachers", link: "/teachers" },
                { text: "Teacher Class Allocation", link: "/teacher-class-allocation" },
                { text: "Teacher Timetable", link: "/teacher-timetable" },
                // { text: "Teacher Leaves", link: "/teacher-leaves" },
                // { text: "Teacher Reports", link: "/teacher-reports" },
                { text: "Homework Allocation", link: "/homework-allocation" },
                { text: "Student Attendance", link: "/student-attendance" },
                // { text: "Exam Result Section", link: "/exam-result-section" },
                // { text: "Teacher Attendance", link: "/teacher-attendance" },

            ]
        },
        {
            icon: "fas fa-money-bill-wave",
            text: "Accounting Mgmt",
            submenu: [
                { text: "Fee Structure Setup", link: "/fee-structure" },
                { text: "Fee Collection", link: "/fee-collection" },
                { text: "Expense Tracking", link: "/expenses" },
                { text: "Income Tracking", link: "/income" },
                { text: "Fee Heads", link: "/fee-head-master" },
                { text: "Ledger", link: "/ledgers" },

            ]
        },

        {
            icon: "fas fa-book",
            text: "Library Mgmt",
            submenu: [
                { text: "Book Catalogue", link: "/books" },
                { text: "Issue Books", link: "/issue-books" },
                { text: "Return Books", link: "/return-books" },
            ]
        },


        {
            icon: "fas fa-bed",
            text: "Hostel Mgmt",
            submenu: [
                { text: "Warden Details", link: "/warden" },
                { text: "Hostel Details", link: "/hostel-details" },
                { text: "Hostel Rooms", link: "/hostel-rooms" },
                { text: "Room Allocation", link: "/room-allocation" },
                { text: "Hostel Attendance", link: "/hostel-attendance" },
                // { text: "Visitor Log", link: "/visitor-log" },
            ]
        },
        {
            icon: "fas fa-warehouse",
            text: "Store Mgmt",
            submenu: [
                { text: "Product Category", link: "/product-category" },
                { text: "Store Products", link: "/store-products" },
                { text: "Purchase Orders", link: "/purchase-orders" },
                { text: "Vendor Mgmt", link: "/vendors" },
                { text: "Student Inventory ", link: "/student-inventory" }
            ]
        },
        {
            icon: "fas fa-utensils",
            text: "Canteen Mgmt",
            submenu: [
                { text: "Daily Entry", link: "/canteen-daily-entry" },
                { text: "Meal Planning", link: "/meal-planning" },
                { text: "Canteen Menu", link: "/canteen-menu" },
                { text: "Canteen Staff", link: "/canteen-staff" },
            ]
        },
        {
            icon: "fas fa-file-invoice-dollar",
            text: "Payroll Mgmt",
            submenu: [
                { text: "Staff Profiles", link: "/users-mgmt" },
                { text: "Payment Allocation", link: "/payment-allocation" },
                { text: "Payslip Generation", link: "/payslips" },
                { text: "Staff Attendance", link: "/attendance" },
                { text: "Advance Payments", link: "/advance-payment" },
                { text: "Monthly Payments", link: "/monthly-payment" }
            ]
        },

        {
            icon: "fas fa-bus",
            text: "Transport Mgmt",
            submenu: [
                // { text: "Student Assignning", link: "/student-assigning" },
                { text: "Driver Allotment", link: "/driver-allotment" },
                { text: "Vehicle Inventory", link: "/vehicles" },
                { text: "Maintenance Tracker", link: "/vehicle-maintenance" },
                { text: "Fuel Logs", link: "/fuel-logs" },
                { text: "Driver Mgmt", link: "/drivers" },
                { text: "Locations", link: "/transport-location" },
                { text: "Location Types", link: "/location-types" },
            ]
        },

        {
            icon: "fas fa-file",
            text: "Certificates",
            submenu: [
                { text: "Bonafide Certificates", link: "/bonafide-certifictes" },
                { text: "TC Certificates", link: "/tc-certifictes" },
                { text: "LC Certificates", link: "/lc-certifictes" },
                { text: "75% More Attendance", link: "/75percent-attendance" },
                { text: "Progress Card", link: "/progress-card" },
                { text: "Id Card Generation", link: "/idcard-generation" },

            ]
        },

        {
            icon: "fas fa-chart-bar",
            text: "Reports & Analytics",
            submenu: [
                { text: "Students Report", link: "/students-reports" },
                // { text: "Attendance Reports", link: "/attendance-reports" },
                { text: "Fee  Collection Reports", link: "/fee-reports" },
                { text: "Fee Headwise Collection", link: "/fee-headwise-collection" },
                { text: "Transport Reports", link: "/transport-reports" },
                // { text: "Pass Entries", link: "/pass-entries" },
                { text: "Homework Reports", link: "/homework-reports" },
                { text: "Income-Expense Report", link: "/income-expense-report" },
                { text: "Vehcial Maintance Report", link: "/vehical-maintance-report" },
                // { text: "Hostel Students", link: "/hostel-report" },
                { text: "Store Inventories", link: "/store-inventories" },
                { text: "Canteen Report", link: "/canteen-report" },
                { text: "Staff Payment Report", link: "/staff-payment-report" },
                { text: "Admission Cancelled List", link: "/admission-canclled-list" },
            ]
        },

        {
            icon: "fas fa-table",
            text: "Master",
            submenu: [


                { text: "School Details", link: "/school-details" },
                { text: "Caste Category", link: "/caste-category" },
                { text: "Religion", link: "/religion" },
                { text: "Bank", link: "/banks" },
                // { text: "Location", link: "/locations" },
                { text: "Medium", link: "/mediums" },
                { text: "Board", link: "/board" },
                // { text: "Examination", link: "/examination" },
                { text: "Bank A/C", link: "/bank-accounts" },
                { text: "Academic Years", link: "/academic-years" },
                { text: "Students Documents", link: "/document-mgmt" },
                { text: "Academic Calender", link: "/academic-calender" },
                { text: "Ledger", link: "/ledgers" },
                // { text: "Holidays", link: "/holidays" },

            ]
        },
        {
            icon: "fas fa-list",
            text: "Sub Master",
            submenu: [
                { text: "Fees Category", link: "/fees-category" },
                { text: "School / College Type", link: "/college-type" },
                { text: "Student Type", link: "/student-type" },
                { text: "Branch", link: "/branches" },
                { text: "Courses / Class", link: "/courses" },
                { text: "Next Course / TC Definition", link: "/next-class-definition" },
                { text: "Subject Definition", link: "/subject-definition" },
                { text: "Fee Heads", link: "/fee-head-master" },
                { text: "Assign Heads to Class", link: "/fee-head-class-assigning" },
                { text: "Fee Discount Types", link: "/fee-discount-types" },
                { text: "Staff Documents", link: "/staff-dcouments" },
                { text: "Exam Types", link: "/exam-types" },
                { text: "Post Types", link: "/post-types" },
                { text: "Hostel Attendance Timing", link: "/hostel-attendance-timing" },
                // { text: "Standard Fees", link: "/standred-fess" },
                // { text: "Exam Standard Fees", link: "/exam-standred-fess" },

            ]
        },



        // { icon: "fas fa-fingerprint", text: "Biometric Connections", link: "/biometric" },
        { icon: "fas fa-users", text: "All Users", link: "/users-mgmt" },
        // { icon: "fas fa-life-ring", text: "Help & Support", link: "/help-support" }

    ];

    const menuToShow = fullMenu;


    return (
        <aside
            className="main-sidebar"
            style={{
                background: "linear-gradient(180deg, #096065 0%, #126668 50%, #08456a 100%)",
                backgroundBlendMode: "soft-light",
                backgroundSize: "cover",
                color: "#fff",
                height: "100vh",
                width: "260px",
                position: "fixed",
                top: 0,
                left: 0,
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* TOP PROFILE BAR */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                    position: "sticky",
                    top: 0,
                    background: "rgba(1, 40, 43, 0.8)",
                    backdropFilter: "blur(6px)",
                    zIndex: 10,
                }}
            >
                {propertyLogo ? (
                    <img
                        src={propertyLogo}
                        alt="Property Logo"
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            margin: "0 auto 10px auto",
                            display: "block",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            background: "#fff"
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            fontWeight: "700",
                            margin: "0 auto 10px auto",
                            color: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                        }}
                    >
                        {firstLetter}
                    </div>
                )}


                <h5 style={{ fontWeight: "600", margin: 0 }}>{username}</h5>

                {propertyName && (
                    <p style={{
                        fontSize: "13px",
                        margin: "4px 0 0",
                        color: "#e0e0ff",
                        fontWeight: "500"
                    }}>
                        {propertyName}
                    </p>
                )}


            </div>

            {/* MENU AREA */}
            {/* MENU AREA */}
            <div
                className="sidebar-scroll"
                style={{
                    padding: "5px 1px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,
                    height: "calc(100vh - 120px)",
                    paddingBottom: "40px"
                }}
            >


                {menuToShow.map((item, index) => (
                    <div
                        key={index}
                        className="menu-parent"
                        style={{ position: "relative" }}

                    >

                        <motion.div
                            onClick={(e) => {
                                if (item.submenu) {
                                    e.preventDefault();
                                    setOpenMenu(openMenu === index ? null : index);
                                } else if (item.link) {
                                    navigate(item.link); // <-- use navigate
                                }
                            }}
                            style={linkStyle}
                            whileHover={linkHover}
                        >
                            <i className={item.icon} style={iconStyle}></i>
                            <span>{item.text}</span>

                            {item.submenu && (
                                <i
                                    className="fas fa-chevron-right arrow-icon"
                                    style={{
                                        ...arrowIconStyle,
                                        transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                    }}
                                ></i>
                            )}
                        </motion.div>


                        {item.submenu && openMenu === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    overflow: "hidden",
                                }}
                            >
                                {item.submenu.map((sub, sIndex) => (
                                    <motion.div
                                        key={sIndex}
                                        onClick={() => {
                                            if (sub.link) navigate(sub.link);
                                        }}
                                        style={{ ...linkStyle, ...submenuStyle, cursor: "pointer" }}
                                        whileHover={linkHover}
                                    >
                                        • {sub.text}
                                    </motion.div>
                                ))}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}

export default Menu;
